
import { 
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	canAccess, 
	AppTabs,
	Edit,
	Create,
	Crud,
	trans
} from '@/router/index'

import Asset from '@/components/modules/assets/Asset'
import AssetTabs from '@/components/modules/assets/AssetTabs'
import AssetStatistics from '@/components/modules/assets/AssetStatistics'
import AssetsSettings from '@/components/modules/assets/settings/AssetsSettings'
import CredentialsSettings from '@/components/modules/assets/settings/CredentialsSettings'
export const assets = [
	{
		path: '/credentials',
		redirect: '/assets/credentials'
	},
	{ 
		path: '/assets', 
		beforeEnter: ifAuthenticated,
		component: AppTabs, 
		props: {
			tabs: [
				{
					to: '/assets/',
					text: 'assets',
				},
				{
					to: '/assets/statistics',
					text: 'Statistiche',
				},
				{
					to: '/assets/credentials',
					text: 'Credenziali',
					model: 'credential'
				},
			],
		},
		children: [
			{
				path: '/assets/',
				name: 'assets-index',
				meta: {
					title: 'assets'
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'assets',
					actionIcon: 'layers',
					title: 'assets',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/assets/statistics',
				meta: {
					title: trans('analytics') + ' ' + trans('asset')
				},
				beforeEnter: ifAuthenticatedOnline,
				component: AssetStatistics,
				props: {
					modelDef: 'assets',
					actionIcon: 'layers',
					title: 'Asset',
				}
			},
			{
				path: '/assets/credentials',
				name: 'credentials-index',
				beforeEnter: (to, from, next) => canAccess('permission', 'credential', next),
				meta: {
					title: trans('credentials') + ' ' + trans('asset')
				},
				component: Crud,
				props: (route) => ({
					title: 'Credenziali',
					actionIcon: 'mdi-key-variant',
					modelDef: 'credentials',
				}),
			},
		],
	},
	{ 
		path: '/assets/create',
		name: 'assets-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'assets',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},	
	{ 
		path: '/assets/:id/edit',
		name: 'assets-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'assets',
			id: parseInt(route.params.id)
		}),
	},
	{ 
		path: '/assets/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AssetTabs,
		props: (route) => ({
			id: parseInt(route.params.id)
		}), 
		children: [
			{
				path: '',
				name: 'assets-show', 
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'asset', next) },
				component: Asset,
				meta: {
					title: 'Asset'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
				}), 
			},
			{
				path: 'tickets',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'trouble', next) },
				component: Crud,
				meta: {
					title: 'Ticket'
				},				
				props: (route) => ({
					title: 'Ticket associati',
					actionIcon: 'receipt',
					modelDef: 'troubles',
					subFilters: {assets: parseInt(route.params.id)},
					defaultInput: {asset_id: parseInt(route.params.id), company_id: parseInt(route.query.company_id)},
				}),
			},
			{
				path: 'credentials',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'credential', next) },
				component: Crud,
				meta: {
					title: 'Credenziali Asset'
				},				
				props: (route) => ({
					title: 'Credenziali associate',
					actionIcon: 'mdi-key-variant',
					modelDef: 'credentials',
					subFilters: {assets: parseInt(route.params.id)},
					defaultInput: {asset_id: parseInt(route.params.id), company_id: parseInt(route.query.company_id)},
				}),
			},
		]
	},
	{
		path: '/settingsassets/',
		name: 'settingsassets',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsassets',
					text: 'Asset',
				},
				{
					to: '/settingsassets/credentials',
					text: 'Credenziali',
				},							
			],
		},
		children: [
			{
				path: '/settingsassets/',
				beforeEnter: ifAuthenticatedOnline,
				component: AssetsSettings,
			},
			{
				path: '/settingsassets/credentials',
				beforeEnter: ifAuthenticatedOnline,
				component: CredentialsSettings,
			},
		],
	},
]